import React from "react";

function OnlineShoppingSvg({ color = "#000000", width = 24, height = 24 }) {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      version="1.1"
      width={width}
      height={height}
      x="0"
      y="0"
      viewBox="0 0 16.933 16.933"
      fill={color}
    >
      <g>
        <path
          d="M3.495.264c-.727 0-1.322.595-1.322 1.323v13.759c0 .727.595 1.322 1.322 1.322h4.58a1.775 1.775 0 0 1-.355-.53 1.711 1.711 0 0 1-.136-.529H3.761c-.29 0-.53-.24-.53-.529V1.852c0-.289.24-.529.53-.529h1.322a.265.265 0 0 1 .264.264v.265c0 .15.116.264.265.264h3.176c.15 0 .264-.115.264-.264v-.265a.265.265 0 0 1 .263-.264h1.325c.289 0 .529.24.529.53V9.2h1.058V1.587c0-.728-.596-1.323-1.324-1.323zM7.2 5.028c-1.02 0-1.853.832-1.853 1.852S6.18 8.73 7.2 8.73c1.02 0 1.852-.83 1.852-1.85S8.22 5.028 7.2 5.028zm.521 1.28a.265.265 0 0 1 .03.001.265.265 0 0 1 .18.094.265.265 0 0 1-.032.373l-.722.611a.265.265 0 0 1-.35-.008l-.336-.306a.265.265 0 0 1-.015-.375.265.265 0 0 1 .373-.016l.164.15.545-.46a.265.265 0 0 1 .163-.063zm1.294 3.42a.265.265 0 0 0-.262.233l-.639 5.36a1.21 1.21 0 0 0 1.198 1.347h4.244a1.21 1.21 0 0 0 1.195-1.347l-.636-5.36a.265.265 0 0 0-.265-.232zm.904 1.12a.265.265 0 0 1 .264.264c0 .7.557 1.261 1.25 1.261.692 0 1.25-.56 1.25-1.261a.265.265 0 0 1 .265-.264.265.265 0 0 1 .264.264 1.79 1.79 0 0 1-1.78 1.79 1.79 1.79 0 0 1-1.779-1.79.265.265 0 0 1 .266-.264zm-5.1 2.91a.265.265 0 0 0-.265.263.265.265 0 0 0 .266.266h2.885l.063-.53z"
          fill={color}
          opacity="1"
          data-original={color}
        ></path>
      </g>
    </svg>
  );
}

export default OnlineShoppingSvg;
